module.exports = __webpack_public_path__ + "static/media/blingV3_12.161f3c21.png";